import { Descriptions, Space } from 'antd';
import { get } from 'lodash';

import { STATUS_LIST } from '../../enum';
import { getMomentDateWithoutTimezone } from '../../utils/datetime';
import Box from '../Box';
import HelpIcon from '../HelpIcon';
import StatusTag from '../Tag/StatusTag';
import Text from '../Text';

const AxleConnectionStatus = ({ t, axleConnectionInfo, asDescription, policyRefreshedAt }) => {
  if (!axleConnectionInfo || !get(axleConnectionInfo, 'status')) return null;

  const isConnectionActive = get(axleConnectionInfo, 'status') === STATUS_LIST().Status.ACTIVE;
  const formattedPolicyRefreshedAt = policyRefreshedAt
    ? getMomentDateWithoutTimezone(policyRefreshedAt).format('MMM DD, YYYY')
    : null;

  if (asDescription) {
    return (
      <Descriptions
        size="small"
        contentStyle={{ alignItems: 'center' }}
        labelStyle={{ alignItems: 'center' }}
      >
        <Descriptions.Item
          label={
            <Text variant="b" size="large" renderAs="p">
              {t('insurance-status')}
            </Text>
          }
        >
          <Space align="center" size="small" direction="horizontal" wrap={false}>
            <StatusTag
              status={isConnectionActive ? 'connected' : get(axleConnectionInfo, 'status')}
            />

            {!isConnectionActive && (
              <HelpIcon
                iconStyle={{ display: 'block' }}
                hint={
                  <div>
                    <Text>{t(`axle-${get(axleConnectionInfo, 'status')}-1`)}</Text>
                    <Text>{t(`axle-${get(axleConnectionInfo, 'status')}-2`)}</Text>
                  </div>
                }
              />
            )}
          </Space>
        </Descriptions.Item>
      </Descriptions>
    );
  }

  return (
    <Box padding="10px" maxWidth="max-content">
      <Space direction="vertical" size="small">
        <Space align="center" size="middle" direction="horizontal" wrap={false}>
          <Text variant="h4" style={{ margin: 0 }}>
            {t('insurance-status')}
          </Text>
          <Space align="center" size="small" direction="horizontal" wrap={false}>
            <StatusTag
              status={isConnectionActive ? 'connected' : get(axleConnectionInfo, 'status')}
            />

            {!isConnectionActive && (
              <HelpIcon
                iconStyle={{ display: 'block' }}
                hint={
                  <div>
                    <Text>{t(`axle-${get(axleConnectionInfo, 'status')}-1`)}</Text>
                    <Text>{t(`axle-${get(axleConnectionInfo, 'status')}-2`)}</Text>
                  </div>
                }
              />
            )}
          </Space>
        </Space>

        {formattedPolicyRefreshedAt && (
          <Text size="small">
            {t('policyLastRefreshedOn')}: {formattedPolicyRefreshedAt}
          </Text>
        )}
      </Space>
    </Box>
  );
};

export default AxleConnectionStatus;
